export const IMAGE_GIF = 'image/gif'

export const IMAGE_JPEG = 'image/jpeg'

export const IMAGE_PNG = 'image/png'
